import React from 'react'
import classNames from 'classnames'
import classes from './styles.module.scss'

interface IStackProps {
  children?: React.ReactNode
  gap?: 'xs' |'sm' | 'md' | 'lg' | 'xl' | 'xxl'
  mt?: 'xs' |'sm' | 'md' | 'lg' | 'xl' | 'xxl'
  mb?: 'xs' |'sm' | 'md' | 'lg' | 'xl' | 'xxl'
  ml?: 'xs' |'sm' | 'md' | 'lg' | 'xl' | 'xxl'
  mr?: 'xs' |'sm' | 'md' | 'lg' | 'xl' | 'xxl'
  my?: 'xs' |'sm' | 'md' | 'lg' | 'xl' | 'xxl'
  mx?: 'xs' |'sm' | 'md' | 'lg' | 'xl' | 'xxl'
  align?: 'start' | 'center' | 'end'
  justify?: 'start' | 'center' | 'end' | 'between' | 'around'
  className?: string
}

export const Stack = (props: IStackProps) => {
  const {
    children,
    gap,
    mt,
    mb,
    ml,
    mr,
    my,
    mx,
    align,
    justify,
    className
  } = props
  return (
    <div
      className={classNames({
        [classes.stack]: true,
        [classes[`gap-${gap}`]]: gap,
        [classes[`mt-${mt}`]]: mt,
        [classes[`mb-${mb}`]]: mb,
        [classes[`ml-${ml}`]]: ml,
        [classes[`mr-${mr}`]]: mr,
        [classes[`my-${my}`]]: my,
        [classes[`mx-${mx}`]]: mx,
        [classes[`align-${align}`]]: align,
        [classes[`justify-${justify}`]]: justify,
      },
      className
      )}>
      {children}
    </div>
  )
}
